@if (avatars.length > 1) {
  @if (grouped) {
    <p-avatarGroup>
      @for (avatar of avatars; track $index) {
        @if (avatar) {
          @if (avatar.icon) {
            <p-avatar
              class="m-avatar"
              [shape]="avatar.shape || 'circle'"
              [styleClass]="avatar.styleClass || ''"
              [style]="{
                height: sizeValue(avatar),
                width: sizeValue(avatar),
                fontSize: fontSize(avatar),
              }">
              <span
                class="flex material-symbols-outlined {{
                  avatar.iconStyleClass
                }}"
                [style]="{ color: avatar.color }"
                >{{ avatar.icon }}</span
              >
            </p-avatar>
          }
          @if (avatar.imageUrl) {
            <p-avatar
              class="m-avatar"
              [image]="avatar.imageUrl"
              [shape]="avatar.shape || 'circle'"
              [styleClass]="avatar.styleClass || ''"
              [style]="{
                height: sizeValue(avatar),
                width: sizeValue(avatar),
                fontSize: fontSize(avatar),
                background: 'transparent',
              }"></p-avatar>
          } @else {
            <p-avatar
              class="m-avatar"
              [shape]="avatar.shape || 'circle'"
              [label]="avatar.initials || 'M'"
              [styleClass]="avatar.styleClass || ''"
              [style]="{
                height: sizeValue(avatar),
                width: sizeValue(avatar),
                fontSize: fontSize(avatar),
                color: avatar.color,
                background: avatar.bg,
              }"></p-avatar>
          }
        }
      }
    </p-avatarGroup>
  } @else {
    <div class="flex items-center gap-2">
      @for (avatar of avatars; track $index) {
        @if (avatar) {
          @if (avatar.imageUrl) {
            <p-avatar
              class="m-avatar"
              [image]="avatar.imageUrl"
              [shape]="avatar.shape || 'circle'"
              [styleClass]="avatar.styleClass || ''"
              [style]="{
                height: sizeValue(avatar),
                width: sizeValue(avatar),
                fontSize: fontSize(avatar),
                background: 'transparent',
              }"></p-avatar>
          } @else {
            <p-avatar
              class="m-avatar"
              [shape]="avatar.shape || 'circle'"
              [label]="avatar.imageUrl ? '' : avatar.initials || 'M'"
              [styleClass]="avatar.styleClass || ''"
              [style]="{
                height: sizeValue(avatar),
                width: sizeValue(avatar),
                fontSize: fontSize(avatar),
                color: avatar.color,
                background: avatar.bg,
              }"></p-avatar>
          }
        }
      }
    </div>
  }
} @else {
  @if (firstAvatar) {
    @if (firstAvatar.icon) {
      <p-avatar
        class="m-avatar"
        [shape]="firstAvatar.shape || 'circle'"
        [styleClass]="firstAvatar.styleClass || ''"
        [style]="{
          height: sizeValue(firstAvatar),
          width: sizeValue(firstAvatar),
          fontSize: fontSize(firstAvatar),
          background: firstAvatar.bg,
        }">
        <span
          class="flex material-symbols-outlined {{
            firstAvatar.iconStyleClass
          }}"
          [style]="{ color: firstAvatar.color }"
          >{{ firstAvatar.icon }}</span
        >
      </p-avatar>
    }
    @if (firstAvatar.imageUrl) {
      <p-avatar
        class="m-avatar"
        [image]="firstAvatar.imageUrl"
        [shape]="firstAvatar.shape || 'circle'"
        [styleClass]="firstAvatar.styleClass || ''"
        [style]="{
          height: sizeValue(firstAvatar),
          width: sizeValue(firstAvatar),
          fontSize: fontSize(firstAvatar),
          background: 'transparent',
        }"></p-avatar>
    } @else if (!firstAvatar.icon) {
      <p-avatar
        class="m-avatar"
        [shape]="firstAvatar.shape || 'circle'"
        [label]="firstAvatar.initials || 'M'"
        [styleClass]="firstAvatar.styleClass || ''"
        [style]="{
          height: sizeValue(firstAvatar),
          width: sizeValue(firstAvatar),
          fontSize: fontSize(firstAvatar),
          color: firstAvatar.color,
          background: firstAvatar.bg,
        }"></p-avatar>
    }
  }
}
